/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

import { Button } from "@/components/ui/button";
import {
  ChevronLeft,
  ChevronRight,
  Fullscreen,
  MonitorDown,
  X,
  ZoomIn,
  ZoomOut,
} from "lucide-react";
import { useEffect, useState } from "react";

export const DocumentImageToolBar = ({
  state,
  setState,
  currentImage,
}: any) => {
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    setZoom(1);
  }, [open]);

  function downloadImage(url: string) {
    // Create an anchor element
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "downloaded-document";

    // Append the anchor to the document body
    document.body.appendChild(anchor);

    // Programmatically click the anchor to trigger the download
    anchor.click();

    // Remove the anchor from the document
    document.body.removeChild(anchor);
  }

  return (
    <div>
      <div className="flex items-center gap-3 justify-center pt-5 ">
        <Button
          variant={"outline"}
          onClick={() => setState({ type: "prev" })}
          disabled={state.currentPage === 1}
        >
          <ChevronLeft />
        </Button>
        <Button variant={"outline"} disabled className="user-select-none">
          {state.currentPage} / {state.images?.length}
        </Button>
        <Button
          variant={"outline"}
          onClick={() => setState({ type: "next" })}
          disabled={state.images?.length === state.currentPage}
        >
          <ChevronRight />
        </Button>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button variant="outline">
              <Fullscreen />
            </Button>
          </DialogTrigger>
          <DialogContent className="min-w-[100%] min-h-[100%] flex items-center justify-center border-none outline-none  bg-transparent ">
            <div className="absolute top-3 right-3 flex gap-3 z-[99] w-full md:w-auto flex-wrap pl-[9%]">
              <Button
                variant={"outline"}
                onClick={() => setState({ type: "prev" })}
                disabled={state.currentPage === 1}
              >
                <ChevronLeft />
              </Button>
              <Button
                variant={"outline"}
                className="user-select-none pointer-events-none"
              >
                {state.currentPage} / {state.images?.length}
              </Button>
              <Button
                variant={"outline"}
                onClick={() => setState({ type: "next" })}
                disabled={state.images?.length === state.currentPage}
              >
                <ChevronRight />
              </Button>
              <Button
                variant={"outline"}
                onClick={() => downloadImage(currentImage)}
              >
                <MonitorDown />
              </Button>
              <Button
                variant={"outline"}
                onClick={() => {
                  setZoom((prev) => prev + 0.1);
                }}
                disabled={zoom > 1.7}
              >
                <ZoomIn />
              </Button>
              <Button
                variant={"outline"}
                onClick={() => {
                  setZoom((prev) => prev - 0.1);
                }}
                disabled={zoom < 0.5}
              >
                <ZoomOut />
              </Button>
              <Button
                className="border-red-500 text-red-500 bg-red-50"
                variant={"outline"}
                onClick={() => setOpen(false)}
              >
                <X />
              </Button>
            </div>
            <div className=" overflow-auto max-h-[calc(100dvh_-_91px)] mt-[51px]">
              <img
                src={currentImage}
                className="scale-200"
                style={{ zoom: zoom }}
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};
